/* YUNAIKO — animations de marque : fonds qui changent de couleur, trait du geste, ajout au panier qui vole.
   Uniquement transform / opacity / couleur de fond. Rien ne s'anime si la visiteuse réduit les animations. */
(() => {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Fonds qui changent de couleur : les sections claires deviennent transparentes,
        un fond unique prend la couleur de la section au centre de l'écran. */
  function initMorph() {
    if (!root.classList.contains('yk-morph') || !('IntersectionObserver' in window)) return;
    const items = [...document.querySelectorAll('.yk-section')].filter((el) => !el.matches('.color-scheme-4, .color-scheme-5, [class*="color-scheme-f2f9"]'));
    if (items.length < 2) return;
    const colors = new Map();
    items.forEach((el) => {
      const c = getComputedStyle(el).backgroundColor;
      if (c && c !== 'rgba(0, 0, 0, 0)') { colors.set(el, c); el.classList.add('yk-morph-item'); }
    });
    const first = colors.get(items[0]) || getComputedStyle(document.body).backgroundColor;
    root.style.setProperty('--yk-backdrop', first);
    document.body.classList.add('yk-morph-body');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting && colors.has(e.target)) root.style.setProperty('--yk-backdrop', colors.get(e.target)); });
    }, { rootMargin: '-50% 0px -50% 0px' });
    colors.forEach((_, el) => io.observe(el));
  }

  /* 2. Trait du geste : se dessine avec le défilement. CSS natif quand le navigateur le permet. */
  function initGesture() {
    const line = document.querySelector('[data-yk-gesture]');
    if (!line) return;
    if (reduce) { line.style.setProperty('--yk-draw', 0); return; }
    if (window.CSS && CSS.supports('animation-timeline: scroll()')) return;
    let raf = null;
    const update = () => {
      raf = null;
      const max = document.documentElement.scrollHeight - innerHeight;
      const p = max > 0 ? Math.min(1, scrollY / max) : 0;
      line.style.setProperty('--yk-draw', (1 - p).toFixed(4));
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }

  /* 3. Ajout au panier qui vole jusqu'à l'icône du panier. */
  function findImage(form) {
    const btn = form.querySelector('[type="submit"]');
    if (btn && btn.dataset.ykFlyImg) return btn.dataset.ykFlyImg;
    const scope = form.closest('.yk-moment, .yk-offer, .yk-final, yk-sticky-atc, .yk-pdp, .yk-section, section') || document;
    const img = scope.querySelector('.yk-sticky__img, .product__media-item.is-active img, .product__media-list img, .yk-moment__media img, .yk-offer__media img, img');
    return img ? (img.currentSrc || img.src) : null;
  }
  function fly(form) {
    if (reduce || !Element.prototype.animate) return;
    const cart = document.getElementById('cart-icon-bubble');
    const btn = form.querySelector('[type="submit"]');
    const src = findImage(form);
    if (!cart || !btn || !src) return;
    const a = btn.getBoundingClientRect();
    const b = cart.getBoundingClientRect();
    if (!b.width) return;
    const size = 56;
    const el = document.createElement('img');
    el.src = src;
    el.alt = '';
    el.className = 'yk-fly';
    el.style.left = `${a.left + a.width / 2 - size / 2}px`;
    el.style.top = `${a.top + a.height / 2 - size / 2}px`;
    document.body.appendChild(el);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = el.animate([
      { transform: 'translate(0, 0) scale(0.6)', opacity: 0 },
      { transform: `translate(${dx * 0.35}px, ${dy * 0.35 - 80}px) scale(1)`, opacity: 1, offset: 0.35 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.25)`, opacity: 0.4 }
    ], { duration: 750, easing: 'cubic-bezier(0.5, 0, 0.3, 1)' });
    anim.onfinish = () => {
      el.remove();
      cart.classList.remove('yk-cart-bump');
      void cart.offsetWidth;
      cart.classList.add('yk-cart-bump');
    };
  }
  function initFly() {
    if (!root.classList.contains('yk-fly-on')) return;
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form.closest('product-form') && form.querySelector('[name="id"]')) fly(form);
    }, true);
  }

  const init = () => { initMorph(); initGesture(); initFly(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
